import(/* webpackMode: "eager" */ "/vercel/path0/app/legals/page.tsx")